import SmartdocLoading from "../components/indicators/SmartdocLoading";

const Loading = () => {
  return <SmartdocLoading />;
};

export default Loading;
